<template>
  <div>
    <PmwModal :value="value" :title="title" @input="$emit('input', $event)">
      <template #default>
        <div class="content">
          <Paragraph
            v-if="showHotelName"
            fontSize="large"
            fontWeight="medium"
            class="mb-3"
          >
            {{ hotelName }}
          </Paragraph>
          <PmwFormSelect
            v-model="selectedRates"
            :options="rateOptions"
            strategy="absolute"
            label="Selecione a tarifa base para excluir"
            placeholder="Selecione a tarifa"
            searchPlaceholder="Buscar por ID ou nome"
            searchOptionsField="always"
            class="pmw-form-select"
          />
        </div>
      </template>

      <template #footer-content>
        <div class="footer-buttons">
          <PmwButton
            :disabled="isDeleting"
            layout="outline"
            variation="blue-100"
            size="large"
            @click="$emit('input', false)"
          >
            Voltar
          </PmwButton>
          <PmwButton v-if="!selectedRates" disabled size="large">
            Excluir Tarifa
          </PmwButton>
          <PmwButton
            v-else
            :disabled="isDeleting"
            variation="error-100"
            size="large"
            @click="confirmDelete"
          >
            Salvar exclusão
          </PmwButton>
        </div>
      </template>
    </PmwModal>

    <!-- MODAL COM LOADER -->
    <LoaderModal v-model="isDeleting" title="Importante">
      <template #text>
        Aguarde enquanto excluímos a tarifa. <br />
        Isso pode levar alguns segundos.
      </template>
    </LoaderModal>
  </div>
</template>

<script>
import PmwModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwModal'
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import Paragraph from '@/components/_base/elements/Paragraph'
import LoaderModal from '@/components/_base/commonComponents/LoaderModal'

export default {
  name: 'DeleteBaseRateModal',
  components: {
    PmwModal,
    PmwFormSelect,
    PmwButton,
    Paragraph,
    LoaderModal
  },
  props: {
    /** Controla a visibilidade do modal */
    value: {
      type: Boolean,
      default: false
    },
    /** Lista de tarifas disponíveis para exclusão */
    rates: {
      type: Array,
      default: () => []
    },
    /** Nome do hotel a ser exibido no modal */
    hotelName: {
      type: String,
      default: ''
    },
    /** Título do modal */
    title: {
      type: String,
      default: 'Excluir tarifa base'
    },
    /** Define se deve exibir o nome do hotel */
    showHotelName: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectedRates: null,
      isDeleting: false
    }
  },
  computed: {
    rateOptions() {
      return this.rates.map((rate) => ({
        text: rate.nome
          ? `ID: ${rate.codigo} - ${rate.nome}`
          : rate.name || rate.title || rate.text,
        value: rate.codigo || rate.id || rate.value
      }))
    }
  },
  watch: {
    value(newVal) {
      if (!newVal) {
        this.selectedRates = null
        this.isDeleting = false
      }
    }
  },
  methods: {
    confirmDelete() {
      if (this.selectedRates && !this.isDeleting) {
        this.isDeleting = true
        /** Envia um array com a tarifa selecionada para manter compatibilidade com o backend */
        const rateIds = [this.selectedRates.value || this.selectedRates]
        this.$emit('delete', rateIds)
      }
    },
    /** Método para ser chamado pelo componente pai após sucesso ou erro */
    finishDelete() {
      this.isDeleting = false
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-bottom: 150px;
}

.footer-buttons {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.pmw-form-select {
  ::v-deep {
    /** Alterar cores do select para azul */
    .pmw-select--button__caret-sort-up,
    .pmw-select--button__show {
      border-bottom-color: pmw-colors('blue-100');
    }

    .pmw-select--button:focus {
      border-color: pmw-colors('blue-100');
      border-bottom-color: pmw-colors('blue-100');
    }

    .pmw-select-options--item__hover:hover,
    .pmw-select-options--item__checked {
      background-color: pmw-colors('blue-100') !important;
    }

    /** Limitar altura da lista de opções */
    .pmw-select-options {
      max-height: 170px;
      overflow-y: auto;
    }
  }
}
</style>
